import { DataGrid, Grid, Paper } from "@pankod/refine-mui";
import React, { useState } from "react";
import HeaderStatistiche from "./HeaderStatistiche";

function StatisticheExtra() {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const columnsExtra = [
    {
      field: "extraName",
      headerName: "Nome Extra",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "extraType",
      headerName: "Tipologia Extra",
      minWidth: 180,
      flex: 1,
      renderCell: ({ row }) => {
        // capitalise each word
        return row.extraType
          .split(" ")
          .map((word) => word[0].toUpperCase() + word.slice(1))
          .join(" ");
      },
    },
    {
      field: "quantity",
      headerName: "Quantità Extra",
      minWidth: 80,
      flex: 1,
    },
    // {
    //   field: "totalRevenuePerBooking",
    //   headerName: "Fatturato a prenotazione",
    //   minWidth: 80,
    //   flex: 1,
    //   valueGetter: ({ row }) => {
    //     return row.totalRevenuePerBooking?.toFixed(2) + " €";
    //   },
    // },
    // {
    //   field: "totalCancellationsAmount",
    //   headerName: "Cancellazioni",
    //   minWidth: 80,
    //   flex: 1,
    //   valueGetter: ({ row }) => {
    //     return row.totalCancellationsAmount?.toFixed(2) + " €";
    //   },
    // },
    {
      field: "revenue",
      headerName: "Fatturato totale",
      minWidth: 80,
      flex: 1,
      valueGetter: ({ row }) => {
        return row.revenue?.toFixed(2) + " €";
      },
    },
  ];

  return (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HeaderStatistiche setData={setData} setLoading={setLoading} />
        </Grid>
        <Grid item xs={12}>
          {data?.extras && (
            <DataGrid
              rows={data?.extras}
              getRowId={(row) => row.extra}
              columns={columnsExtra}
              pageSize={data?.extras?.length}
              pagination
              components={{
                Pagination: () => {
                  return null;
                },
              }}
              autoHeight
              sx={{
                border: "none",
                "& .MuiDataGrid-columnHeaders": {
                  background: "rgb(242, 242, 242)",
                  borderBottom: "1px solid rgb(229, 229, 229)",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid rgb(242, 242, 242)",
                },
              }}
              disableSelectionOnClick={true}
            />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
}

export default StatisticheExtra;
